<template>
    <section>
        <div id="main-slider-controls" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img :src="appUrl+'/guest/images/banner-1.jpg'" class="d-block w-100" alt="Carousel Image 1">
                    <div class="carousel-caption d-none d-md-block">
                        <h3>Best School Accessories</h3>
                        <p>This is a test description</p>
                        <a href="" class="cta-btn">Shop Now</a>
                    </div>
                </div>
                <div class="carousel-item">
                    <img :src="appUrl+'/guest/images/banner-1.jpg'" class="d-block w-100" alt="Carousel Image 2">
                    <div class="carousel-caption d-none d-md-block">
                        <h3>Best School Accessories</h3>
                        <p>This is a test description</p>
                        <a href="" class="cta-btn">Shop Now</a>
                    </div>
                </div>
                <div class="carousel-item">
                    <img :src="appUrl+'/guest/images/banner-1.jpg'" class="d-block w-100" alt="Carousel Image 3">
                    <div class="carousel-caption d-none d-md-block">
                        <h3>Best School Accessories</h3>
                        <p>This is a test description</p>
                        <a href="" class="cta-btn">Shop Now</a>
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#main-slider-controls" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#main-slider-controls" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </section>
</template>
<script>
    export default {
        computed: {},
        data() {
            return {
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
            };
        },
        mounted() {
            //console.log(this.appUrl);
        },
    };
</script>
